import { Eye, Pencil, Trash2 } from "lucide-react";
import type { ActionItem } from "@/components/ui/actions-dropdown";
import type { ActionSurface } from "./types";

export interface TenantActionsContext {
  surface: ActionSurface;
  canRequestDeletion: boolean;
  onView: () => void;
  onEdit: () => void;
  onRequestDeletion: () => void;
}

const L = (s: ActionSurface, list: string, detail: string) =>
  s === "list" ? list : detail;

export function buildTenantActions(ctx: TenantActionsContext): ActionItem[] {
  const { surface } = ctx;
  const items: ActionItem[] = [];
  if (surface === "list") {
    items.push({ label: "View Details", icon: Eye, onClick: ctx.onView });
  }
  items.push({
    label: L(surface, "Edit", "Edit Tenant"),
    icon: Pencil,
    onClick: ctx.onEdit,
  });
  if (ctx.canRequestDeletion) {
    items.push({
      label: L(surface, "Request Deletion", "Request Tenant Deletion"),
      icon: Trash2,
      onClick: ctx.onRequestDeletion,
      destructive: true,
    });
  }
  return items;
}
